import { Entry } from '../Entry'

export function Entry20221026() {
  return (
    <Entry title="26/10/2022 - v3.2.9">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13274/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
